module.exports = __webpack_public_path__ + "img/29bb79c6230b4f704f5a646075b65482.png";